import createAction from '@/Framework/State/Redux/createAction';
import { SET_META_TAGS } from './actionTypes';

export const setMetaTags = (payload) => createAction(SET_META_TAGS, payload);
